import { useRum } from '@/context/RumContext'
import { recordPageView } from '@/lib/rum'
import { useLocation } from '@tanstack/react-router'
import { useEffect } from 'react'

export const RumPageTracker: React.FC = () => {
  const location = useLocation()
  const { isInitialized } = useRum()

  useEffect(() => {
    if (isInitialized) {
      recordPageView(location.pathname)
    }
  }, [location.pathname, isInitialized])

  return null
}

export default RumPageTracker
